// Data no fuso do aparelho (horário de Brasília para os usuários), no formato de <input type="date">.
// Não usar toISOString().slice(0, 10): ele converte para UTC e, a partir das 21h, devolve o dia seguinte.
export function toLocalDateInput(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
